import React, { useEffect, useState } from 'react';
import {
  generatePath,
  useHistory,
  useParams,
  useRouteMatch
} from 'react-router-dom';
import { useEntityContext } from 'containers/pages/persons/store/useEntityContext';
import { useSessionContext } from 'contexts/SessionContext';
import { useTestDataContext } from 'contexts/TestDataContext';
import { useAbility } from '@casl/react';
import { AbilityContext } from 'Can';
import { useContextMenu } from 'contexts/ContextMenuProvider';
import useEdit from 'hooks/utils/useEdit';
import {
  ROUTE_PERSONS_ENTITY,
  ROUTE_PERSONS_ENTITY_PERSON_SESSIONS_SESSION,
  ROUTE_PERSONS_ENTITY_PERSON_SESSIONS_SESSION_TESTS_TESTDATA_EDIT
} from 'routes/RouteList';
import GenerateMagicLinkButton from 'containers/partials/buttons/GenerateMagicLinkButton';
import RemoveSporterFromSessionButton from 'containers/partials/buttons/RemoveSporterFromSessionButton';
import slugify from 'slugify';
import messages from 'messages';
import Loader from 'components/loader/Loader';
import EditTestResultCard from 'containers/partials/cards/EditTestResultCard';
import GenerateMagicURLModal from 'containers/partials/modals/GenerateMagicURLModal';

const PersonSessionDataTab = () => {
  const { entityId, groupId, sessionId, personId } = useParams();
  const { push } = useHistory();
  const person = useEntityContext(s => s.person);
  const { session } = useSessionContext();
  const { testDataLoading } = useTestDataContext();
  const ability = useAbility(AbilityContext);
  const { setMenuItems, clearAllContext } = useContextMenu();
  const [edit] = useEdit(
    !!useRouteMatch(
      [ROUTE_PERSONS_ENTITY_PERSON_SESSIONS_SESSION_TESTS_TESTDATA_EDIT],
      true
    )
  );
  const [openGenerateMagicURLModal, setOpenGenerateMagicURLModal] =
    useState(false);

  const GenerateMagicLinkBtn = () => (
    <GenerateMagicLinkButton
      menu
      person={person}
      onClick={() => setOpenGenerateMagicURLModal(true)}
    />
  );

  const RemoveSporterFromSessionBtn = () => (
    <RemoveSporterFromSessionButton
      menu
      rootEntityId={entityId}
      sessionId={session.id}
      ids={[personId]}
      onComplete={() =>
        push(
          generatePath(ROUTE_PERSONS_ENTITY, {
            entityId,
            groupId
          })
        )
      }
      dataQa={`${slugify(messages.menuItemSessionRemoveSporter.id.toLowerCase())}-menu`}
    />
  );

  useEffect(() => {
    const contextButtons = [];

    if (ability.can('manage', 'Sessions')) {
      contextButtons.push(<RemoveSporterFromSessionBtn />);
    }

    if (session.isRecurring && ability.can('manage', 'Sessions')) {
      contextButtons.push(<GenerateMagicLinkBtn />);
    }

    setMenuItems(contextButtons);

    return () => {
      // Cleanup action buttons and context menu items
      clearAllContext();
    };
  }, [person, ability, sessionId]);

  if (testDataLoading) {
    return <Loader />;
  }

  return (
    <>
      <EditTestResultCard
        entityId={entityId}
        personId={personId}
        edit={edit}
        rootPath={generatePath(ROUTE_PERSONS_ENTITY_PERSON_SESSIONS_SESSION, {
          entityId,
          groupId,
          personId,
          sessionId
        })}
      />
      {openGenerateMagicURLModal && (
        <GenerateMagicURLModal
          entityId={entityId}
          person={person}
          destiny={sessionId}
          onClose={() => setOpenGenerateMagicURLModal(false)}
        />
      )}
    </>
  );
};

export default PersonSessionDataTab;
